export class Shipper {
  /**
   * constructor description
   * @param {Object} shipper - An object.
   * @param  {String} shipper.filter_type
   * @param  {String[]?} shipper.countries
   * @param  {String[]?} shipper.states
  */
  constructor({ filter_type, countries, states }) {
    this.filter_type = filter_type;
    this.countries = countries;
    this.states = states;
  }
}
